<template>
  <div class="stock-industry">
    <div class="page-header">
      <div class="page-title">
        <div class="title-icon">
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="3" y="3" width="7" height="7" rx="1" stroke="currentColor" stroke-width="2"/>
            <rect x="14" y="3" width="7" height="7" rx="1" stroke="currentColor" stroke-width="2"/>
            <rect x="14" y="14" width="7" height="7" rx="1" stroke="currentColor" stroke-width="2"/>
            <rect x="3" y="14" width="7" height="7" rx="1" stroke="currentColor" stroke-width="2"/>
          </svg>
        </div>
        <h1>行业筛选</h1>
        <div class="title-decoration"></div>
      </div>
      <p class="page-subtitle">按行业分类浏览股票，快速发现投资机会</p>
    </div>

    <div class="filter-bar">
      <el-select
        v-model="selectedIndustry"
        placeholder="请选择行业"
        clearable
        @change="handleIndustryChange"
        class="filter-select"
        v-loading="industryLoading"
      >
        <el-option
          v-for="item in industries"
          :key="item"
          :label="item"
          :value="item"
        >
        </el-option>
      </el-select>

      <el-input
        v-model="searchKeyword"
        placeholder="搜索股票名称或代码"
        prefix-icon="el-icon-search"
        clearable
        class="search-input"
        @input="handleSearch"
      >
      </el-input>

      <el-button type="primary" @click="fetchData">查询</el-button>
      <el-button @click="resetFilters">重置</el-button>
    </div>

    <div class="stock-count">共找到 <strong>{{ stockList.length }}</strong> 只股票</div>

    <el-table
      :data="paginatedStockList"
      v-loading="loading"
      border
      stripe
      style="width: 100%"
      class="stock-table"
    >
      <el-table-column prop="stock_code" label="股票代码" width="110" align="center">
      </el-table-column>
      <el-table-column prop="stock_name" label="股票名称" width="120" align="center">
      </el-table-column>
      <el-table-column prop="exchange" label="交易所" width="80" align="center">
      </el-table-column>
      <el-table-column prop="industry" label="行业" width="180">
      </el-table-column>
      <el-table-column prop="market_cap" label="总市值(亿)" width="110" align="right">
        <template slot-scope="scope">
          {{ scope.row.market_cap ? (Number(scope.row.market_cap) / 100000000).toFixed(2) : '-' }}
        </template>
      </el-table-column>
      <el-table-column prop="circulating_market_cap" label="流通市值(亿)" width="120" align="right">
        <template slot-scope="scope">
          {{ scope.row.circulating_market_cap ? (Number(scope.row.circulating_market_cap) / 100000000).toFixed(2) : '-' }}
        </template>
      </el-table-column>
      <el-table-column prop="pe_ttm" label="市盈率TTM" width="100" align="right">
        <template slot-scope="scope">
          {{ scope.row.pe_ttm !== null && scope.row.pe_ttm !== undefined ? Number(scope.row.pe_ttm).toFixed(2) : '-' }}
        </template>
      </el-table-column>
      <el-table-column prop="pb" label="市净率" width="90" align="right">
        <template slot-scope="scope">
          {{ scope.row.pb !== null && scope.row.pb !== undefined ? Number(scope.row.pb).toFixed(2) : '-' }}
        </template>
      </el-table-column>
      <el-table-column prop="roe" label="ROE(%)" width="90" align="right">
        <template slot-scope="scope">
          {{ scope.row.roe !== null && scope.row.roe !== undefined ? Number(scope.row.roe).toFixed(2) : '-' }}
        </template>
      </el-table-column>
      <el-table-column prop="gross_profit_margin" label="毛利率(%)" width="100" align="right">
        <template slot-scope="scope">
          {{ scope.row.gross_profit_margin !== null && scope.row.gross_profit_margin !== undefined ? Number(scope.row.gross_profit_margin).toFixed(2) : '-' }}
        </template>
      </el-table-column>
      <el-table-column prop="net_profit_margin" label="净利率(%)" width="100" align="right">
        <template slot-scope="scope">
          {{ scope.row.net_profit_margin !== null && scope.row.net_profit_margin !== undefined ? Number(scope.row.net_profit_margin).toFixed(2) : '-' }}
        </template>
      </el-table-column>
      <el-table-column prop="listed_date" label="上市日期" width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.listed_date || '-' }}
        </template>
      </el-table-column>
      <el-table-column label="操作" width="280" align="center" fixed="right">
        <template slot-scope="scope">
          <el-button
            type="text"
            size="small"
            @click.stop="viewKLine(scope.row, 'day')"
          >
            日K
          </el-button>
          <el-button
            type="text"
            size="small"
            @click.stop="viewKLine(scope.row, 'week')"
          >
            周K
          </el-button>
          <el-button
            type="text"
            size="small"
            @click.stop="viewKLine(scope.row, '5min')"
          >
            5分
          </el-button>
          <el-button
            type="text"
            size="small"
            :loading="scope.row.adding"
            @click.stop="addToFavorite(scope.row)"
          >
            自选
          </el-button>
          <el-button
            type="text"
            size="small"
            @click.stop="copyStockCode(scope.row)"
          >
            复制
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[20, 50, 100, 200]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="stockList.length"
      class="pagination"
    >
    </el-pagination>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'StockIndustry',
  data() {
    return {
      loading: false,
      industryLoading: false,
      stockList: [],
      filteredStockList: [],
      industries: [],
      selectedIndustry: '',
      searchKeyword: '',
      currentPage: 1,
      pageSize: 50,
      userId: '1'
    }
  },
  computed: {
    paginatedStockList() {
      const start = (this.currentPage - 1) * this.pageSize
      const end = start + this.pageSize
      return this.filteredStockList.slice(start, end)
    }
  },
  mounted() {
    this.fetchIndustries()
  },
  methods: {
    async fetchIndustries() {
      this.industryLoading = true
      try {
        // 使用新的 industry2 接口，从 stock_basic_info2 获取行业列表
        const response = await axios.get('/stock/info/industry-classification')
        console.log('行业接口返回:', response.data)

        if (response.data.status === 'success' && response.data.data) {
          // 接口返回的是行业列表数组
          this.industries = response.data.data.sort()
          console.log('提取的行业列表:', this.industries)
        } else {
          this.industries = []
        }
      } catch (error) {
        console.error('获取行业失败:', error)
        this.$message.error('获取行业失败')
        this.industries = []
      } finally {
        this.industryLoading = false
      }
    },

    async fetchData() {
      this.loading = true
      try {
        const params = {}
        if (this.selectedIndustry) {
          params.industry = this.selectedIndustry
        }

        console.log('请求参数:', params)
        // 使用新的 industry2 接口，从 stock_basic_info2 获取数据
        const response = await axios.get('/stock/info/industry2', { params })
        console.log('股票数据接口返回:', response.data)

        if (response.data.status === 'success' && response.data.data) {
          this.stockList = response.data.data
          console.log('解析为股票数据，数量:', this.stockList.length)
          this.applyFilters()
        } else {
          this.stockList = []
          this.filteredStockList = []
        }
      } catch (error) {
        console.error('获取股票数据失败:', error)
        this.$message.error('获取股票数据失败')
        this.stockList = []
        this.filteredStockList = []
      } finally {
        this.loading = false
      }
    },

    handleIndustryChange() {
      this.currentPage = 1
      if (this.selectedIndustry) {
        this.fetchData()
      } else {
        this.stockList = []
        this.filteredStockList = []
      }
    },

    handleSearch() {
      this.currentPage = 1
      this.applyFilters()
    },

    applyFilters() {
      let result = [...this.stockList]

      if (this.searchKeyword) {
        const keyword = this.searchKeyword.toLowerCase()
        result = result.filter(item =>
          (item.stock_code && item.stock_code.toLowerCase().includes(keyword)) ||
          (item.stock_name && item.stock_name.toLowerCase().includes(keyword)) ||
          (item.alias_code && item.alias_code.toLowerCase().includes(keyword))
        )
      }

      this.filteredStockList = result
      console.log('筛选后的股票列表:', this.filteredStockList.length)
    },

    resetFilters() {
      this.selectedIndustry = ''
      this.searchKeyword = ''
      this.currentPage = 1
      this.stockList = []
      this.filteredStockList = []
    },

    viewKLine(row, type) {
      const routeMap = {
        'day': '/kline/day',
        'week': '/kline/week',
        '5min': '/kline/5min'
      }
      this.$router.push({
        path: routeMap[type],
        query: { code: row.stock_code }
      })
    },

    async addToFavorite(row) {
      this.$set(row, 'adding', true)
      try {
        const response = await axios.post('/stock/favorite/add', {
          user_id: this.userId,
          stock_code: row.stock_code,
          stock_name: row.stock_name,
          remark: '',
          sort_order: 0
        })
        if (response.data.status === 'success') {
          this.$message.success(`已将 ${row.stock_name} 添加到自选`)
        } else {
          this.$message.error(response.data.message || '添加失败')
        }
      } catch (error) {
        console.error('添加自选失败:', error)
        this.$message.error('添加自选失败: ' + (error.response?.data?.message || error.message))
      } finally {
        this.$set(row, 'adding', false)
      }
    },

    handleSizeChange(val) {
      this.pageSize = val
    },

    handleCurrentChange(val) {
      this.currentPage = val
    },

    copyStockCode(row) {
      const code = row.stock_code
      navigator.clipboard.writeText(code).then(() => {
        this.$message.success({
          message: `已复制: ${code}`,
          duration: 2000
        })
      }).catch(err => {
        console.error('复制失败:', err)
        this.$message.error({
          message: '复制失败',
          duration: 2000
        })
      })
    }
  }
}
</script>

<style scoped>
.stock-industry {
  padding: 20px;
  min-height: calc(100vh - 104px);
  position: relative;
}

.page-header {
  text-align: center;
  margin-bottom: 32px;
  position: relative;
  z-index: 1;
}

.page-title {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  margin-bottom: 8px;
}

.title-icon {
  width: 48px;
  height: 48px;
  background: linear-gradient(135deg, rgba(99, 102, 241, 0.2) 0%, rgba(139, 92, 246, 0.2) 100%);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #a5b4fc;
  border: 1px solid rgba(99, 102, 241, 0.3);
  box-shadow: 0 0 20px rgba(99, 102, 241, 0.15);
}

.title-icon svg {
  width: 24px;
  height: 24px;
}

.page-title h1 {
  margin: 0;
  font-size: 32px;
  font-weight: 700;
  background: linear-gradient(135deg, #a5b4fc 0%, #c4b5fd 50%, #a5b4fc 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  letter-spacing: 1px;
}

.title-decoration {
  width: 60px;
  height: 3px;
  background: linear-gradient(90deg, transparent 0%, #6366f1 50%, transparent 100%);
  border-radius: 2px;
}

.page-subtitle {
  margin: 0;
  color: #64748b;
  font-size: 14px;
  letter-spacing: 0.5px;
}

.filter-bar {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 24px;
  flex-wrap: wrap;
  padding: 20px 24px;
  background: rgba(255, 255, 255, 0.03);
  backdrop-filter: blur(20px);
  border-radius: 16px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3),
              inset 0 1px 0 rgba(255, 255, 255, 0.05);
  position: relative;
  z-index: 1;
}

.filter-select {
  width: 240px;
}

.filter-select :deep(.el-input__inner),
.search-input :deep(.el-input__inner) {
  background: rgba(15, 23, 42, 0.6);
  border: 1px solid rgba(99, 102, 241, 0.2);
  color: #e2e8f0;
  border-radius: 8px;
  transition: all 0.3s ease;
}

.filter-select :deep(.el-input__inner):hover,
.search-input :deep(.el-input__inner):hover {
  border-color: rgba(99, 102, 241, 0.4);
  box-shadow: 0 0 12px rgba(99, 102, 241, 0.15);
}

.filter-select :deep(.el-input__inner):focus,
.search-input :deep(.el-input__inner):focus {
  border-color: #6366f1;
  box-shadow: 0 0 16px rgba(99, 102, 241, 0.25);
}

.filter-select :deep(.el-input__inner)::placeholder,
.search-input :deep(.el-input__inner)::placeholder {
  color: rgba(226, 232, 240, 0.4);
}

.search-input {
  width: 240px;
}

.filter-bar :deep(.el-button--primary) {
  background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%);
  border: none;
  border-radius: 8px;
  padding: 10px 24px;
  font-weight: 500;
  box-shadow: 0 4px 16px rgba(99, 102, 241, 0.3);
  transition: all 0.3s ease;
}

.filter-bar :deep(.el-button--primary):hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 24px rgba(99, 102, 241, 0.45);
}

.filter-bar :deep(.el-button--default) {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  padding: 10px 24px;
  color: #cbd5e1;
  transition: all 0.3s ease;
}

.filter-bar :deep(.el-button--default):hover {
  background: rgba(255, 255, 255, 0.1);
  border-color: rgba(255, 255, 255, 0.2);
  color: #e2e8f0;
}

.stock-count {
  margin-bottom: 16px;
  color: #94a3b8;
  font-size: 14px;
  padding: 10px 16px;
  background: rgba(99, 102, 241, 0.08);
  border-radius: 8px;
  border-left: 3px solid #6366f1;
  display: inline-block;
  position: relative;
  z-index: 1;
}

.stock-count strong {
  color: #a5b4fc;
  font-weight: 600;
}

.stock-table {
  margin-bottom: 20px;
  border-radius: 12px;
  overflow: hidden;
  position: relative;
  z-index: 1;
}

.stock-table :deep(.el-table__header-wrapper) {
  background: linear-gradient(180deg, rgba(30, 41, 59, 0.9) 0%, rgba(15, 23, 42, 0.9) 100%);
}

.stock-table :deep(.el-table__header th) {
  background: transparent;
  color: #cbd5e1;
  font-weight: 600;
  border-bottom: 1px solid rgba(99, 102, 241, 0.2);
  padding: 14px 0;
}

.stock-table :deep(.el-table__body) {
  background: rgba(15, 23, 42, 0.5);
}

.stock-table :deep(.el-table__body tr) {
  background: transparent;
  transition: all 0.25s ease;
}

.stock-table :deep(.el-table__body tbody tr:hover > td) {
  background: rgba(99, 102, 241, 0.08) !important;
}

.stock-table :deep(.el-table__body td) {
  border-bottom: 1px solid rgba(255, 255, 255, 0.03);
  color: #e2e8f0;
  padding: 12px 0;
}

.stock-table :deep(.el-table__body-wrapper) {
  background: rgba(15, 23, 42, 0.3);
  border: 1px solid rgba(255, 255, 255, 0.06);
  border-radius: 0 0 12px 12px;
}

.stock-table :deep(.el-button--text) {
  color: #a5b4fc;
  transition: all 0.2s ease;
}

.stock-table :deep(.el-button--text:hover) {
  color: #c7d2fe;
  text-shadow: 0 0 8px rgba(165, 180, 252, 0.4);
}

/* 操作列居中 */
.stock-table :deep(.el-table__cell.el-table__cell) {
  text-align: center;
}

.stock-table :deep(.el-table__body td.el-table__cell) {
  text-align: center;
}

.pagination {
  display: flex;
  justify-content: flex-end;
  position: relative;
  z-index: 1;
}

.pagination :deep(.el-pagination) {
  color: #94a3b8;
}

.pagination :deep(.el-pagination .el-pager li) {
  background: rgba(15, 23, 42, 0.6);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 6px;
  margin: 0 4px;
  min-width: 32px;
  height: 32px;
  line-height: 30px;
  transition: all 0.25s ease;
}

.pagination :deep(.el-pagination .el-pager li:hover) {
  border-color: rgba(99, 102, 241, 0.4);
  color: #a5b4fc;
}

.pagination :deep(.el-pagination .el-pager li.active) {
  background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%);
  border-color: transparent;
  color: #ffffff;
  font-weight: 600;
}

.pagination :deep(.el-pagination button) {
  background: rgba(15, 23, 42, 0.6);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 6px;
  color: #94a3b8;
  transition: all 0.25s ease;
}

.pagination :deep(.el-pagination button:hover) {
  border-color: rgba(99, 102, 241, 0.4);
  color: #a5b4fc;
}

.pagination :deep(.el-pagination .el-pagination__sizes .el-select .el-input .el-input__inner) {
  background: rgba(15, 23, 42, 0.6);
  border: 1px solid rgba(255, 255, 255, 0.08);
  color: #e2e8f0;
  border-radius: 6px;
}

.pagination :deep(.el-pagination .el-pagination__jump) {
  color: #94a3b8;
}

.filter-select :deep(.el-select-dropdown) {
  background: rgba(15, 23, 42, 0.95) !important;
  border: 1px solid rgba(99, 102, 241, 0.2) !important;
  backdrop-filter: blur(20px);
}

.filter-select :deep(.el-select-dropdown__item) {
  color: #e2e8f0 !important;
}

.filter-select :deep(.el-select-dropdown__item:hover) {
  background: rgba(99, 102, 241, 0.15) !important;
}

.filter-select :deep(.el-select-dropdown__item.selected) {
  color: #a5b4fc !important;
  background: rgba(99, 102, 241, 0.1) !important;
}
</style>
